/*

https://next.vuetifyjs.com/en/components/data-tables#api

{
  text: string
  value: string
  align?: 'start' | 'center' | 'end'
  sortable?: boolean
  divider?: boolean
  class?: string | string[]
  width?: string | number
  filter?: (value: any, search: string, item: any) => boolean
  sort?: (a: any, b: any) => number
}

 */

export const blacklistedFields = [
  'created_user',
  'created_date',
  'last_edited_user',
  'last_edited_date',
];

export const serviceAreas = [
  {
    value: 'properties.County',
    text: 'County',
    sortable: true,
    align: 'left',
    width: 130,
    class: [],
  },
  {
    value: 'properties.ProviderName',
    text: 'Provider Name',
    sortable: true,
    align: 'left',
    class: [],
  },
  {
    value: 'properties.Location',
    text: 'Community',
    sortable: true,
    align: 'left',
    class: [],
  },
  {
    value: 'properties.Speeds_mbps',
    text: 'Speed',
    sortable: true,
    align: 'center',
    width: 100,
    class: [],
  },
  {
    value: 'properties.Type',
    text: 'Service Type',
    sortable: true,
    align: 'center',
    width: 130,
    class: [],
  },
];

export const serviceAreasAlts = serviceAreas.map(item => {
  const newItem = { ...item, };
  newItem.value = `Publication.DBO.CommunicationProjects.${item.value}`;
  return newItem;

});

export default {
  serviceAreas,
  serviceAreasAlts,
  blacklistedFields,
};
